/* eslint-disable react-hooks/rules-of-hooks */
import React, { memo, useCallback, useMemo, useRef, useState } from 'react';
import { Header, Wrapper } from '../../components/layout/header';
import useSWR from 'swr';
import { GeneralApi, OptionApi, UserApi, ValuationApi, VehicleApi } from '../../apis';
import { Formik, FormikErrors, FormikProps } from 'formik';
import {
  Button,
  Col,
  Empty,
  Form,
  InputNumber,
  message,
  Modal,
  Row,
  Select,
  Tag,
} from 'antd';
import { NumberInput, SelectInput, TextInput } from '../../components/form/fields/number-input';
import styled from 'styled-components';
import { CircleQuestionMark, MinusIcon, PlusIcon, SearchIcon } from 'lucide-react';
import * as Yup from 'yup';
import { useField } from 'formik';
import { IGeneral } from '../../interfaces';
import { CarImagesUpload } from '../../components/valuation/car-images';
import { Colors } from '../../constant/color';
import { QuerySearch } from '../../components/form/query-search';
import dayjs from 'dayjs';
import {
  currencyFormatter,
  currencyParser,
  delay,
  downloadPDF,
  formatCurrency,
  formatter,
  parser,
  scrollAndSubmit,
  scrollToId,
  textFormatter,
  uploadFirstFour,
} from '../../utils';
import { useNavigate } from 'react-router-dom';
import { NavigationRoutes } from '../../navigation/type';
import { useSelector } from 'react-redux';
import { AuthState } from '../../store/reducer/auth';
import { PLATE_RE } from '../../components/valuation/register-no';
import { REG_NO, VIN_REGEX } from '../../components/valuation/custom';
import * as yup from 'yup';
import { FINALIZE_PERCENT, getFinalizePolicy } from '../../constant/finalize-percent';

const HomeScreen = memo(() => {
  const [payload, setPayload] = useState<any>();
  const { data: general } = useSWR('/api/init', () => GeneralApi.init());
  const { data: me } = useSWR('/api/user/me', () => UserApi.me());
  const navigate = useNavigate();

  React.useEffect(() => {
    const init = () => {
      if (!me) {
        return;
      }

      const valuation = me?.permissions['VALUATION'];

      if (!valuation.isCreate) {
        navigate(NavigationRoutes.Valuation_ListScreen);
      }
    };

    init();
  }, [me, navigate]);

  if (!general) {
    return <div />;
  }

  return (
    <>
      <Wrapper style={{ backgroundColor: 'transparent' }}>
        <div className="flex flex-col h-[49px] bg-[white] justify-center pt-[10px]">
          <Header
            title="Үнэлгээ хийх"
            isGoBack={false}
            className=" flex flex-row items-center bg-white px-[14px]"
          />
        </div>
        <div className="flex flex-row py-[14px]">
          <div className="w-[280px]">
            <div className="w-[280px] rotate-0 opacity-100 flex gap-4 rounded-[10px] border p-[14px] py-[24px] border-[#E5E7EB] bg-[#FFFFFF]">
              <InquireForm setPayload={setPayload} />
            </div>

            <div className="h-[24px]" />
            {/* history list */}
            <div className=" w-[280px] rotate-0 opacity-100 p-[14px] py-[24px] gap-4 rounded-[10px] border border-[#E5E7EB] bg-white">
              <div className="font-manrope font-bold text-[14px] leading-[20px] tracking-[0.2px] uppercase text-[#6A7282]">
                ТҮҮХ
              </div>
              {payload?.valuationHistories?.rows?.length > 0 ? (
                payload.valuationHistories.rows
                  .slice(0, 5)
                  .map((item: any, index: number) => <HistoryCard key={index} payload={item} />)
              ) : (
                <div>
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Хоосон байна" />
                </div>
              )}

              {/* card */}
            </div>
          </div>
          <div className="w-[24px]" />
          <div>
            <div className="font-manrope font-medium text-[18px] leading-[100%] tracking-[0%] align-middle">
              Хайлтын үр дүн
            </div>
            <div className="h-[24px]" />

            <div className="flex flex-row">
              <div>
                <div className="py-[2.5px] font-manrope font-normal text-[12px] leading-[16px] tracking-[0px] text-[#6A7282]">
                  Тайлангийн огноо
                </div>
                <div className="py-[2.5px] font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]">
                  {dayjs().format('YYYY-MM-DD')}
                </div>
              </div>
              <div className="w-[20px]" />
              <div>
                <div className="py-[2.5px] font-manrope font-normal text-[12px] leading-[16px] tracking-[0px] text-[#6A7282]">
                  Үнэлсэн ажилтны нэр
                </div>
                <div className="py-[2.5px] font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]">
                  {me && me?.fullName}
                </div>
              </div>
            </div>
            {/* additional form  */}

            {/* <AdditionalForm /> */}

            <div className="h-[24px]" />
            {payload ? (
              <Editable payload={payload} setPayload={setPayload} key="1" />
            ) : (
              <Editable payload={payload} setPayload={setPayload} key="2" />
            )}
            <div className="h-[24px]" />
            {/* <UploadImagesContainer /> */}
          </div>
        </div>
      </Wrapper>
    </>
  );
});

HomeScreen.displayName = 'HomeScreen';

export { HomeScreen };

const ValuationContainer = ({
  values,
  setFieldValue,
  payload,
  setPayload,
}: {
  values: any;
  setPayload: (e: any) => void;
  payload: any;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean
  ) => Promise<void | FormikErrors<any>>;
}) => {
  const [_values, _setValues] = useState<any>({
    percentOdo: 0,
    percentBranchHead: 0,
  });

  const [imageUrls, setImageUrls] = useState<string[]>([]);
  const { data: currentUser } = useSWR('/api/user/me', UserApi.me);
  const { canFinalize, canForward, forwardLabel } = getFinalizePolicy(currentUser, payload?.percentBranchHead);
  const [finalizedVersion, setFinalizedVersion] = useState<string>();
  const [downloadingReport, setDownloadingReport] = useState(false);
  const valuationVersion = JSON.stringify([
    payload?.id, payload?.price, payload?.percentBranchHead,
    payload?.percentOdo, payload?.hasVat, imageUrls,
  ]);
  const isFinalized = finalizedVersion === valuationVersion;


  // const percentOdoPlus = useCallback(async () => {
  //   if (payload?.percentOdo >= 5) {
  //     return null;
  //   }

  //   const newPercent = payload?.percentOdo + 1;

  //   const res: any = await ValuationApi.calculate({
  //     percentBranchHead: payload.percentBranchHead,
  //     amount: payload.price,
  //     percentOdo: newPercent,
  //     hasVat: payload.hasVat || false,
  //   });

  //   setPayload({
  //     ...payload,
  //     percentOdo: newPercent,
  //     priceFinal: res,
  //   }); // setFieldValue('priceFinal', res);
  //   // setFieldValue('percentOdo', newPercent);
  // }, [payload, setPayload]);

  const percentOdoMinus = useCallback(async () => {
    if (payload?.percentOdo <= -5) {
      return null;
    }

    const newPercent = payload?.percentOdo - 1;

    const res: any = await ValuationApi.calculate({
      percentBranchHead: payload.percentBranchHead,
      amount: payload.price,
      percentOdo: newPercent,
      hasVat: payload?.hasVat || false,
    });

    setPayload({
      ...payload,
      percentOdo: newPercent,
      priceFinal: res,
    });
  }, [payload, setPayload]);

  const branchHeadPercentPlus = async () => {
    if (payload?.percentBranchHead >= FINALIZE_PERCENT.BRANCH_MANAGER.max) {
      return null;
    }

    const newPercent = payload.percentBranchHead + 1;

    const res: any = await ValuationApi.calculate({
      percentBranchHead: newPercent,
      amount: payload?.price,
      percentOdo: payload?.percentOdo,
      hasVat: payload?.hasVat || false,
    });

    setPayload({
      ...payload,
      percentBranchHead: newPercent,
      priceFinal: res,
    });
  };

  const branchHeadPercentMinus = async () => {
    if (payload?.percentBranchHead <= FINALIZE_PERCENT.ZM.min) return;
    
    const newPercent = payload?.percentBranchHead - 1;
    const res: any = await ValuationApi.calculate({
      percentBranchHead: newPercent,
      amount: payload?.price,
      percentOdo: payload?.percentOdo,
      hasVat: payload?.hasVat || false,
    });

    setPayload({
      ...payload,
      percentBranchHead: newPercent,
      priceFinal: res,
    });
  };

  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { accessToken } = useSelector((state: { auth: AuthState }) => state?.auth);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data: general } = useSWR('/api/init', GeneralApi.init);
  const formikRef = useRef<FormikProps<{ reason?: string }>>(null);

  const validationSchema = yup.object().shape({
    reason: yup.string().required('Заавал оруулна'),
  });

  const showModal = () => {
    setIsModalOpen(true);
  };

  const onSubmit = async (values: any) => {
    try {
      setLoading(true);
      await ValuationApi.returnCustomer(values, payload?.id);
      setLoading(false);
      setIsModalOpen(false);
      messageApi.success('Амжилттай');
      navigate(NavigationRoutes.Valuation_ListScreen);
    } catch (error: any) {
      setLoading(false);
      messageApi.error(error?.message);
    }
  };

  const handleOk = async () => {
    const res = await formikRef.current?.submitForm();
    if (res) {
      // onSubmit(res);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    // setAction(undefined);
  };

  const sendBranchHead = async () => {
    if (!canForward || loading || downloadingReport || isFinalized) return;
    if (imageUrls && imageUrls.length !== 4) {
      messageApi.error('Та зургаа оруулна уу ', 4 - imageUrls.length);
      return;
    }

    messageApi.loading('Хүлээнэ үү...');
    try {
      setLoading(true);
      const imgs = await uploadFirstFour(imageUrls, accessToken!);

      console.log('imgs :', imgs);
      console.log('imageUrls :', imageUrls);

      await ValuationApi.finalize({
        id: payload?.id,
        // percentOdo: payload.percentOdo,
        percentBranchHead: payload.percentBranchHead,
        imageUrls: imgs,
        hasVat: payload?.hasVat || false,
      });

      setLoading(false);
      messageApi.destroy();
      messageApi.success('Амжилттай');
      navigate(NavigationRoutes.Valuation_ListScreen);
    } catch (error: any) {
      setLoading(false);
      messageApi.destroy();
      messageApi.error(error?.message);
    }
  };

  const reportDone = async () => {
    if (!canFinalize || loading || downloadingReport || isFinalized) return;
    if (imageUrls && imageUrls.length !== 4) {
      messageApi.error('Зураг дутуу байна !');
      return;
    }
    messageApi.loading('Хүлээнэ үү...');
    try {
      setLoading(true);
      const imgs = await uploadFirstFour(imageUrls, accessToken!);

      await ValuationApi.finalize({
        id: payload?.id,
        percentOdo: payload.percentOdo,
        percentBranchHead: payload.percentBranchHead,
        imageUrls: imgs,
        hasVat: payload?.hasVat || false,
      });

      setFinalizedVersion(valuationVersion);
      setLoading(false);
      messageApi.destroy();
      messageApi.success('Амжилттай');
    } catch (error: any) {
      setLoading(false);
      messageApi.destroy();
      messageApi.error(error?.message);
    }
  };

  const downloadReport = async () => {
    if (!isFinalized || loading || downloadingReport) return;
    setDownloadingReport(true);
    try {
      const report = await ValuationApi.pdf(payload.id);
      downloadPDF(report.url);
    } catch (error: any) {
      messageApi.error(error?.message || 'PDF татахад алдаа гарлаа');
    } finally {
      setDownloadingReport(false);
    }
  };

  React.useEffect(() => {
    _setValues(payload);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {contextHolder}
      <CarImagesUpload onChange={(e) => setImageUrls(e)} />
      <div className="h-[24px]" />
      <div className="w-full h-[409px] rotate-0 opacity-100 pt-[21px] pr-[21px] pb-[1px] pl-[21px] gap-4 rounded-[10px] border border-[#E5E7EB] bg-white">
        <div className="font-inter font-normal text-[14px] leading-[20px] tracking-[0.2px] uppercase text-[#6A7282]">
          ҮНЭЛГЭЭ
        </div>

        <div className="h-[15px]" />
        <div className="flex flex-col">
          <div className="flex w-full h-[41px] border-b my-[8px] pb-[12px]">
            <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px]  leading-[20px] tracking-[-0.15px] text-[#4A5565]">
              Үнэлгээний аргачлал
            </div>
            <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]">
              <div>
                <p className="font-inter font-normal text-[12px] leading-[19.5px] tracking-[0px] text-[#6A7282]">
                  {payload?.description}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col">
          <div className="flex w-full h-[41px] border-b my-[8px] pb-[12px]">
            <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px]  leading-[20px] tracking-[-0.15px] text-[#4A5565]">
              Зохицуулагдсан үнэлгээ
              <div className="w-[29px]" />
              <CircleQuestionMark width={15} height={15} color="#99A1AF" />
            </div>
            <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]">
              <div>
                <p className="font-inter text-[#101828] font-normal text-[12px] leading-[19.5px] tracking-[0px] ">
                  {formatCurrency(payload?.price)}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="flex flex-col">
          <div className="flex w-full h-[41px] border-b my-[8px] pb-[12px]">
            <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px]  leading-[20px] tracking-[-0.15px] text-[#4A5565]">
              Километрийн заалтаас хамаарсан зохицуулалт
              <div className="w-[29px]" />
              <CircleQuestionMark width={15} height={15} color="#99A1AF" />
            </div>
            <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]">
              <div>
                <p className="font-inter text-[#101828] font-normal text-[12px] leading-[19.5px] tracking-[0px] ">
                  <div className="flex flex-row">
                    <div
                      className="w-[30px] h-[30px] rotate-0 opacity-100  rounded-[4px] border border-[#D1D5DC] flex items-center justify-center"
                      onClick={percentOdoPlus}
                    >
                      <PlusIcon width={18.5} height={18.5} />
                    </div>
                    <div className="w-[30px] h-[30px] rotate-0 opacity-100  rounded-[4px] flex items-center justify-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#0A0A0A]">
                      {payload?.percentOdo || 0}%
                    </div>
                    <div
                      className="w-[30px] h-[30px] rotate-0 opacity-100  rounded-[4px] border border-[#D1D5DC] flex items-center justify-center"
                      onClick={percentOdoMinus}
                    >
                      <MinusIcon width={18.5} height={18.5} />
                    </div>
                  </div>
                </p>
              </div>
            </div>
          </div>
        </div> */}

        <div className="flex flex-col">
          <div className="flex w-full h-[41px] border-b my-[8px] pb-[12px]">
            <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px]  leading-[20px] tracking-[-0.15px] text-[#4A5565]">
              Салбарын удирдлагын зохицуулалт
            </div>
            <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]">
              <div>
                <p className="font-inter text-[#101828] font-normal text-[12px] leading-[19.5px] tracking-[0px] ">
                  <div className="flex flex-row">
                    <div
                      onClick={branchHeadPercentPlus}
                      className="w-[30px] h-[30px] rotate-0 opacity-100  rounded-[4px] border border-[#D1D5DC] flex items-center justify-center"
                    >
                      <PlusIcon width={18.5} height={18.5} />
                    </div>
                    <div className="w-[30px] h-[30px] rotate-0 opacity-100  rounded-[4px] flex items-center justify-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#0A0A0A]">
                      {payload?.percentBranchHead || 0}%
                    </div>
                    <div
                      onClick={branchHeadPercentMinus}
                      className="w-[30px] h-[30px] rotate-0 opacity-100  rounded-[4px] border border-[#D1D5DC] flex items-center justify-center"
                    >
                      <MinusIcon width={18.5} height={18.5} />
                    </div>
                  </div>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="h-[15px]" />
        <div className="flex flex-col">
          <div className="flex w-full h-[41px] border-b my-[8px] pb-[12px]">
            {/* <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px]  leading-[20px] tracking-[-0.15px] text-[#4A5565]">
              НӨАТ орсон эсэх
            </div>
            <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]">
              <div>
                <Checkbox
                  checked={payload?.hasVat || false}
                  onChange={async (e) => {
                    
                    const res: any = await ValuationApi.calculate({
                      percentBranchHead: payload?.percentBranchHead,
                      amount: payload?.price,
                      percentOdo: payload?.percentOdo,
                      hasVat: e.target.checked,
                    });

                    setPayload({
                      ...payload,
                      percentBranchHead: payload?.percentBranchHead,
                      priceFinal: res,
                      hasVat: e.target.checked,
                    });

                  }}
                />
              </div>
            </div> */}
          </div>
        </div>

        <div className="flex flex-col">
          <div className="flex w-full h-[41px] my-[8px] pb-[12px]">
            <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px]  leading-[20px] tracking-[-0.15px] text-[#4A5565]">
              Эцэслэсэн үнэлгээ
              <div className="w-[29px]" />
              <CircleQuestionMark width={15} height={15} color="#99A1AF" />
            </div>
            <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]">
              <div>
                <p className="font-inter text-[#101828] font-normal text-[12px] leading-[19.5px] tracking-[0px] ">
                  {formatCurrency(payload?.priceFinal)}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/*  */}
      </div>

      <div className="h-[20px]" />

      <div className="w-full h-[99px] flex flex-row justify-end rotate-0 opacity-100 pt-[21px] pr-[21px] pb-[1px] pl-[21px] gap-4 rounded-[10px] border border-[#E5E7EB] bg-white">
        <Button size="large" loading={loading} onClick={showModal}>
          Харилцагч Буцаах
        </Button>
        <BlackButtonContainer>
          <Button
            type="primary"
            size="large"
            loading={loading}
            onClick={sendBranchHead}
            disabled={!canForward || isFinalized || downloadingReport}
          >
            {forwardLabel}
          </Button>
        </BlackButtonContainer>
       
        <BlueButtonContainer>
          <Button
            type="primary"
            size="large"
            loading={downloadingReport}
            onClick={downloadReport}
            disabled={!isFinalized || loading}
          >
            PDF татах
          </Button>
        </BlueButtonContainer>

         <BlueButtonContainer>
          <Button
            type="primary"
            size="large"
            loading={loading}
            onClick={reportDone}
            disabled={!canFinalize || isFinalized || downloadingReport}
          >
            Үнэлэх
          </Button>
        </BlueButtonContainer>
        
      </div>

      {isModalOpen && (
        <Modal
          title="Харилцагч Буцаах"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          okText="Хадгалах"
          cancelText="Цуцлах"
          maskClosable={false}
          loading={loading}
        >
          <Formik
            onSubmit={onSubmit}
            innerRef={formikRef}
            initialValues={{ reason: undefined }}
            validationSchema={validationSchema}
          >
            {({ values, errors, touched }) => {
              console.log('ERROR :', errors);

              return (
                <Form layout="vertical">
                  <div>
                    <Form.Item
                      label="Шалтгаан"
                      name="reason"
                      validateStatus={errors.reason && touched.reason ? 'error' : ''}
                      help={errors.reason && touched.reason ? errors.reason : ('' as any)}
                    >
                      <SelectInput
                        size="large"
                        name="reason"
                        options={(general?.valuationReturnCustomerReasons || []).map((e: any) => ({
                          label: e.name,
                          value: e.code,
                        }))}
                        placeholder="Сонгох"
                      />
                    </Form.Item>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </Modal>
      )}
    </>
  );
};

// export const AutoScrollToError = () => {
//   const { errors } = useFormikContext();

//   useEffect(() => {
//     const keys = Object.keys(errors);
//     if (keys.length > 0) {
//       const el = document.getElementById(keys[0]);
//       el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
//     }
//   }, [errors]);

//   return null;
// };

export const Editable = ({
  payload,
  setPayload,
  disabled = false,
  additionalInfoHide = false,
}: {
  payload: any;
  setPayload: any;
  disabled?: boolean;
  additionalInfoHide?: boolean;
}) => {
  const { data: general } = useSWR<IGeneral>('/api/init', GeneralApi.init);
  const [messageApi, contextHolder] = message.useMessage();
  const [action, setAction] = useState({
    payload: undefined,
  });
  // antd editable

  const CURR = new Date().getFullYear();

  const formSchema = Yup.object().shape({
    engineCapacity: Yup.string().required('Заавал оруулана уу'),
    condition: Yup.string().required('Заавал оруулана уу'),
    steering: Yup.string().required('Заавал оруулана уу'),
    engineType: Yup.string().required('Заавал оруулана уу'),
    exteriorColor: Yup.string().required('Заавал оруулана уу'),
    manufacturedYear: Yup.number()
      .typeError('Он буруу')
      .required('Заавал оруулах')
      .max(CURR, 'Ирээдүйн он')
      .test('lte-imported', 'Үйлдвэрлэсэн он нь импортолсон оноос их байж болохгүй', function (v) {
        const { importedYear } = this.parent;
        if (!v || !importedYear) return true;
        return v <= importedYear; // ≤
      }),

    importedYear: Yup.number()
      .typeError('Он буруу')
      .required('Заавал оруулах')
      .max(CURR, 'Ирээдүйн он')
      .test(
        'gte-manufactured',
        'Импортолсон он нь үйлдвэрлэсэн оноос бага байж болохгүй',
        function (v) {
          const { manufacturedYear } = this.parent;
          if (!v || !manufacturedYear) return true;
          return v >= manufacturedYear; // ≥
        }
      ),

    registerNo: Yup.string()
      .transform((v) => (v ? v.toUpperCase().replace(/\s/g, '') : v))
      .matches(REG_NO, 'Формат: 2 крилл үсэг + 8 тоо (ж: УБ12345678)')
      .required('Заавал оруулана уу'),

    fullName: Yup.string().required('Заавал оруулана уу'),
    price: Yup.number().required('Заавал оруулана уу').min(1, 'Заавал оруулана уу'),

    carModel: Yup.string().required('Заавал оруулана уу'),
    carBrand: Yup.string().required('Заавал оруулана уу'),

    drivetrain: Yup.string().required('Заавал оруулана уу'),
    odo: Yup.string().required('Заавал оруулана уу'),
    interiorColor: Yup.string().required('Заавал оруулана уу'),
    transmission: Yup.string().required('Заавал оруулана уу'),

    // vin: Yup.string().required('Заавал оруулана уу'),
    vin: Yup.string()
      .trim()
      .when('condition', {
        is: 'UNLICENSED',
        then: (s) =>
          s
            .required('Дугаар аваагүй бол VIN-ийг заавал оруулна.')
            .matches(VIN_REGEX, 'VIN буруу форматтай. Жишээ: GWS00000000000000'),
        otherwise: (s) =>
          // оруулаагүй бол зөвшөөрнө, харин оруулбал regex шалгана
          s
            .notRequired()
            .test('vin-optional', 'VIN буруу форматтай.', (v) => !v || VIN_REGEX.test(v)),
      }),
    // plateNumber: Yup.string().required('Заавал оруулана уу'),
    plateNumber: Yup.string()
      .trim()
      .transform((v) => (v ? v.toUpperCase().replace(/\s+/g, '') : v))
      .when('condition', {
        is: 'LICENSED',
        then: (s) =>
          s
            .required('Дугаар авсан бол улсын дугаарыг заавал оруулна.')
            .matches(PLATE_RE, 'Формат: эхний 4 нь тоо, сүүлийн 3 нь крилл том үсэг (ж: 5929УНС)'),
        otherwise: (s) =>
          // оруулаагүй бол зөвшөөрнө, харин оруулбал regex шалгана
          s
            .notRequired()
            .test('vin-optional', 'Улсын дугаар буруу форматтай.', (v) => !v || VIN_REGEX.test(v)),
      }),
  });

  const initialData = useMemo(() => {
    if (payload) {
      return {
        type: undefined,
        vin: undefined,
        plateNumber: undefined,
        engineCapacity: undefined,
        condition: undefined,
        steering: undefined,
        engineType: undefined,
        exteriorColor: undefined,
        manufacturedYear: undefined,
        importedYear: undefined,
        option: undefined,
        registerNo: undefined,
        fullName: undefined,
        price: undefined,
        drivetrain: undefined,
        odo: undefined,
        interiorColor: undefined,
        percentOdo: 0,
        transmission: undefined,
        percentBranchHead: 0,
        ...payload,
        carBrand: payload?.carBrand?.id,
        carModel: payload?.carModel?.id,
        valuationHistories: undefined,
        customsNo: undefined,
      };
    }

    return {
      type: undefined,
      vin: undefined,
      plateNumber: undefined,
      engineCapacity: undefined,
      condition: undefined,
      steering: undefined,
      engineType: undefined,
      exteriorColor: undefined,
      manufacturedYear: undefined,
      importedYear: undefined,
      option: undefined,
      registerNo: undefined,
      fullName: undefined,
      price: undefined,
      percentOdo: 0,
      percentBranchHead: 0,
      carBrand: undefined,
      carModel: undefined,
      drivetrain: undefined,
      odo: undefined,
      interiorColor: undefined,
      transmission: undefined,
    };
  }, [payload]);

  const navigate = useNavigate();
  const [data, setData] = useState<any>({});
  const [loading, setLoading] = useState(false);

  const valuateType = useMemo(() => {
    if (payload && Object.keys(payload || {}).length !== 0) {
      if (payload?.plateNumber) {
        return 'PLATE_NUMBER';
      } else if (payload?.vin) {
        return 'VIN';
      } else {
        return 'CUSTOM';
      }
    } else {
      return 'CUSTOM';
    }
  }, [payload]);

  const onSubmit = async (values: any) => {
    try {
      setLoading(true);
      messageApi.loading('Хүлээнэ үү...');

      const res = await ValuationApi.valuate({
        ...values,
        carModelId: values?.carModel,
        carBrandId: values?.carBrand,
        valuateType: valuateType,
        engineCapacity:
          typeof values.engineCapacity === 'string'
            ? values.engineCapacity
            : `${values.engineCapacity}`,
      });

      setData(res);
      messageApi.destroy();
      messageApi.success('Амжилттай');
      setAction({ payload: res });

      await delay(300);

      scrollToId('validationContainer');
      scrollToId('isComparableFalse');
      setLoading(false);
    } catch (error: any) {
      messageApi.destroy();
      messageApi.error(error?.message);
      setLoading(false);
    }
  };

  const appraisalSendValuation = () => {
    navigate(`/sendvaluation/${data?.id}`);
  };

  return (
    <>
      {contextHolder}
      <Container>
        <Formik
          enableReinitialize
          onSubmit={(values) => onSubmit(values)}
          initialValues={initialData}
          validationSchema={formSchema}
        >
          {({ handleChange, values, errors, touched, setFieldValue, handleSubmit }) => {
            return (
              <div className={disabled === true ? 'pointer-events-none' : ''}>
                {/* <AutoScrollToError /> */}
                {additionalInfoHide === false && (
                  <div className="w-[1048px] h-[153px] rotate-0 opacity-100 pt-[21px] pr-[21px] pb-[1px] pl-[21px] gap-4 rounded-[10px] border border-[#E5E7EB] bg-white">
                    <div className="font-manrope font-bold text-[14px] leading-[20px] tracking-[0.2px] uppercase text-[#6A7282]">
                      Нэмэлт мэдээлэл
                    </div>
                    <div className="h-[15.5px]" />
                    <div>
                      <Row gutter={16}>
                        <Col span={6}>
                          <Form.Item
                            label="Овог, нэр"
                            name="fullName"
                            layout="vertical"
                            validateStatus={
                              errors?.fullName && touched?.fullName ? 'error' : undefined
                            }
                            help={
                              errors?.fullName &&
                              touched?.fullName &&
                              typeof errors.fullName === 'string'
                                ? errors.fullName
                                : undefined
                            }
                            id="fullName"
                          >
                            <TextInput placeholder="Овог, нэр" name="fullName" />
                          </Form.Item>
                        </Col>

                        <Col span={6}>
                          <Form.Item
                            label="Регистрийн дугаар"
                            name="registerNo"
                            layout="vertical"
                            validateStatus={
                              errors?.registerNo && touched?.registerNo ? 'error' : undefined
                            }
                            help={
                              errors?.registerNo &&
                              touched?.registerNo &&
                              typeof errors.registerNo === 'string'
                                ? errors.registerNo
                                : undefined
                            }
                            id="registerNo"
                          >
                            <TextInput placeholder="Регистрийн дугаар" name="registerNo" />
                          </Form.Item>
                        </Col>

                        <Col span={6}>
                          <Form.Item
                            id="optionId"
                            label="Тоноглол"
                            name="tonoglol"
                            layout="vertical"
                          >
                            <QuerySearch
                              value={values?.option}
                              onChange={(e) => setFieldValue('optionId', e)}
                              placeholder="Тоноглол"
                              showSearch
                              loadData={OptionApi.select(values?.carModel) as any}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={6}>
                          <Form.Item
                            label="Үнэ"
                            name="price"
                            layout="vertical"
                            id="price"
                            validateStatus={errors?.price && touched?.price ? 'error' : ''}
                            help={
                              errors?.price && touched?.price && typeof errors.price === 'string'
                                ? errors.price
                                : undefined
                            }
                          >
                            <NumberInput
                              name="price"
                              placeholder="Үнэ"
                              parser={currencyParser}
                              formatter={currencyFormatter}
                              style={{ width: '100%' }}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  </div>
                )}
                <div className="h-[23px]" />
                <div className="w-full rotate-0 opacity-100 pt-[21px] pr-[21px] pb-[1px] pl-[21px] gap-4 rounded-[10px] border border-[#E5E7EB] bg-white">
                  <Form
                    layout="horizontal"
                    style={{ display: 'flex', flex: 1, width: '100%', flexDirection: 'column' }}
                  >
                    <div className="flex w-full h-[41px] border-b my-[8px] ">
                      <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px]  leading-[20px] tracking-[-0.15px] text-[#4A5565]">
                        Марк
                      </div>
                      <div
                        id="carBrand"
                        className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]"
                      >
                        <EditableItem
                          name={'carBrand'}
                          options={(general?.carBrands || []).map((item) => ({
                            label: item.name,
                            value: item.id,
                          }))}
                        />
                      </div>
                    </div>

                    <div className="flex w-full h-[41px] border-b my-[8px]">
                      <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px]  leading-[20px] tracking-[-0.15px] text-[#4A5565]">
                        Загвар
                      </div>
                      <div
                        id="carModel"
                        className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]"
                      >
                        <EditableItem
                          name="carModel"
                          options={(general?.carModels || [])
                            ?.filter((item: any) => item?.carBrandId === values?.carBrand)
                            ?.map((item) => ({
                              label: item.name,
                              value: item.id,
                            }))}
                        />
                      </div>
                    </div>

                    <div className="flex w-full h-[41px] border-b my-[8px]">
                      <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px]  leading-[20px] tracking-[-0.15px] text-[#4A5565]">
                        Дугаар авсан эсэх
                      </div>
                      <div
                        id="condition"
                        className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]"
                      >
                        <EditableItem
                          name="condition"
                          options={general?.vehicleConditions.map((e) => ({
                            label: e.name,
                            value: e.code,
                          }))}
                        />
                      </div>
                    </div>

                    {/* {LICENSED} */}

                    {/* {values.condition === 'LICENSED' && ( */}
                    <div className="flex w-full h-[41px] border-b my-[8px]">
                      <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px]  leading-[20px] tracking-[-0.15px] text-[#4A5565]">
                        Улсын дугаар
                      </div>
                      <div
                        id="plateNumber"
                        className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]"
                      >
                        <EditableItem name="plateNumber" />
                      </div>
                    </div>
                    {/* // )} */}

                    <div className="flex w-full h-[41px] border-b my-[8px]">
                      <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px]  leading-[20px] tracking-[-0.15px] text-[#4A5565]">
                        Арлын дугаар
                      </div>
                      <div
                        id="vin"
                        className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]"
                      >
                        <EditableItem name="vin" />
                      </div>
                    </div>

                    <div className="flex w-full h-[41px] border-b my-[8px]">
                      <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px]  leading-[20px] tracking-[-0.15px] text-[#4A5565]">
                        Хурдны хайрцаг
                      </div>
                      <div
                        id="transmission"
                        className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]"
                      >
                        <EditableItem
                          name="transmission"
                          options={general?.transmissionTypes.map((e) => ({
                            label: e.name,
                            value: e.code,
                          }))}
                        />
                      </div>
                    </div>

                    <div className="flex w-full h-[41px] border-b my-[8px]">
                      <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px]  leading-[20px] tracking-[-0.15px] text-[#4A5565]">
                        Үйлдвэрлэсэн он
                      </div>
                      <div
                        id="manufacturedYear"
                        className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]"
                      >
                        <EditableItem
                          name="manufacturedYear"
                          options={general?.yearsFrom2000.map((e) => ({ label: e, value: e }))}
                        />
                      </div>
                    </div>

                    <div className="flex w-full h-[41px] border-b my-[8px]">
                      <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px]  leading-[20px] tracking-[-0.15px] text-[#4A5565]">
                        Монгол Улсад орж ирсэн он
                      </div>
                      <div
                        id="importedYear"
                        className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]"
                      >
                        <EditableItem
                          name="importedYear"
                          options={general?.yearsFrom2000.map((e) => ({ label: e, value: e }))}
                        />
                      </div>
                    </div>

                    <div className="flex w-full h-[41px] border-b my-[8px]">
                      <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px]  leading-[20px] tracking-[-0.15px] text-[#4A5565]">
                        Явсан км
                      </div>
                      <div
                        id="odo"
                        className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]"
                      >
                        <EditableItem name="odo" type="number" isNumberFormat />
                      </div>
                    </div>

                    <div className="flex w-full h-[41px] border-b my-[8px]">
                      <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px]  leading-[20px] tracking-[-0.15px] text-[#4A5565]">
                        Хөдөлгүүрийн төрөл
                      </div>
                      <div
                        id="engineType"
                        className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]"
                      >
                        <EditableItem name="engineType" options={general?.engineTypes} />
                      </div>
                    </div>

                    <div className="flex w-full h-[41px] border-b my-[8px]">
                      <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px]  leading-[20px] tracking-[-0.15px] text-[#4A5565]">
                        Хөтлөгч
                      </div>
                      <div
                        id="drivetrain"
                        className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]"
                      >
                        <EditableItem name="drivetrain" options={general?.drivetrain} />
                      </div>
                    </div>

                    <div className="flex w-full h-[41px] border-b my-[8px]">
                      <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px]  leading-[20px] tracking-[-0.15px] text-[#4A5565]">
                        Хөдөлгүүрийн багтаамж
                      </div>
                      <div
                        id="engineCapacity"
                        className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]"
                      >
                        <EditableItem name="engineCapacity" options={general?.engineCapacities} />
                      </div>
                    </div>

                    <div className="flex w-full h-[41px] border-b my-[8px]">
                      <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px]  leading-[20px] tracking-[-0.15px] text-[#4A5565]">
                        Хүрдний байрлал
                      </div>
                      <div
                        id="steering"
                        className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]"
                      >
                        <EditableItem name="steering" options={general?.steeringTypes} />
                      </div>
                    </div>

                    <div className="flex w-full h-[41px] border-b my-[8px]">
                      <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px]  leading-[20px] tracking-[-0.15px] text-[#4A5565]">
                        Гадна өнгө
                      </div>
                      <div
                        id="exteriorColor"
                        className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]"
                      >
                        <EditableItem name="exteriorColor" options={general?.exteriorColors} />
                      </div>
                    </div>

                    <div className="flex w-full h-[41px] border-b my-[8px]">
                      <div className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#4A5565]">
                        Салоны өнгө
                      </div>
                      <div
                        id="interiorColor"
                        className="flex flex-1 flex-row items-center font-inter font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-[#101828]"
                      >
                        {/* {values.vehicle.seats} */}
                        <EditableItem name="interiorColor" options={general?.interiorColors} />
                      </div>
                    </div>
                    {additionalInfoHide === false && (
                      <div className="flex flex-row justify-end h-[60px] items-center">
                        <BlueButtonContainer>
                          <Button
                            className="w-[186px]"
                            type="primary"
                            size="large"
                            disabled={action.payload ? true : false}
                            loading={loading}
                            onClick={() => {
                              scrollAndSubmit({ errors, handleSubmit });
                            }}
                          >
                            Үнэлэх
                          </Button>
                        </BlueButtonContainer>
                      </div>
                    )}
                  </Form>
                </div>
                <div className="h-[24px]" />
                {action?.payload && (action?.payload as any)?.isComparable === true && (
                  <div id="validationContainer">
                    <ValuationContainer
                      values={values as any}
                      setFieldValue={setFieldValue}
                      payload={action.payload}
                      setPayload={(e: any) => {
                        setAction({
                          payload: e,
                        });
                      }}
                    />
                  </div>
                )}

                {action?.payload && (action?.payload as any)?.isComparable === false && (
                  <div
                    id="isComparableFalse"
                    className="w-full bg-white h-[221px] flex flex-col justify-center items-center rotate-0 opacity-100 pr-[21px] pl-[21px] gap-4 rounded-[10px] border"
                  >
                    <div className="flex flex-row justify-center">
                      <svg
                        width="53"
                        height="56"
                        viewBox="0 0 53 56"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0 26.5C0 11.8645 11.8645 0 26.5 0C41.1355 0 53 11.8645 53 26.5V29.5C53 44.1355 41.1355 56 26.5 56C11.8645 56 0 44.1355 0 29.5V26.5Z"
                          fill="#EFF6FF"
                        />
                        <path
                          d="M37.375 38.875L32.1308 33.6309"
                          stroke="#155DFC"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M25.2917 36.4583C30.6304 36.4583 34.9583 32.1304 34.9583 26.7917C34.9583 21.4529 30.6304 17.125 25.2917 17.125C19.9529 17.125 15.625 21.4529 15.625 26.7917C15.625 32.1304 19.9529 36.4583 25.2917 36.4583Z"
                          stroke="#155DFC"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>

                    <div className="font-manrope  font-normal text-[14px] leading-[100%] tracking-[0px] uppercase text-[#284495B0]">
                      Харьцуулах автомашины мэдээлэл олдсонгүй.
                    </div>
                    <BlueButtonContainer>
                      <Button type="primary" onClick={appraisalSendValuation}>
                        Үнэлгээчнээр үнэлүүлэх
                      </Button>
                    </BlueButtonContainer>
                  </div>
                )}

                {/* {action.payload && (action?.payload as any)?.isComparable === false && (
                  <div className="w-[1048px] h-[221px] rotate-0 opacity-100 pr-[21px] pl-[21px] gap-4 rounded-[10px] border">
                    content
                  </div>
                )} */}
              </div>
            );
          }}
        </Formik>
      </Container>
    </>
  );
};

const BlackButtonContainer = styled.div`
  .ant-btn-primary {
    background-color: #101828 !important;
    border-color: #101828 !important;
  }

  .ant-btn-primary:hover,
  .ant-btn-primary:focus {
    background-color: #0a0a0a !important;
    border-color: #0a0a0a !important;
  }

  /* DISABLED state */
  .ant-btn-primary.ant-btn-disabled,
  .ant-btn-primary:disabled {
    background-color: #6b7280 !important; /* сааралдуу disabled өнгө */
    border-color: #6b7280 !important;
    color: #ffffff80 !important; /* 50% white text */
    cursor: not-allowed !important;
    opacity: 0.7;
    box-shadow: none !important;
  }
`;

export const BlueButtonContainer = styled.div`
  .ant-btn-primary {
    background-color: ${Colors.blue} !important;
    border-color: ${Colors.blue} !important;
  }

  .ant-btn-primary:hover,
  .ant-btn-primary:focus {
    background-color: ${Colors.blue} !important;
    border-color: ${Colors.blue} !important;
  }
`;

const Container = styled.div`
  /* .ant-btn-color-primary {
    background-color: ${Colors.blue} !important;
  }
  .ant-tabs-tab {
    margin: 0 5px !important;
  } */
`;

export const EditableItem = ({
  name,
  options,
  type = 'text',
  isNumberFormat,
}: {
  name: string;
  options?: any[];
  type?: 'text' | 'number';
  isNumberFormat?: boolean;
}) => {
  const [field, meta, helpers] = useField(name);
  const { value } = field; // ✅ ЗӨВ
  const { error, touched } = meta;
  const { setValue } = helpers;

  const [editing, setEditing] = useState(false);
  const [temp, setTemp] = useState(value);

  const hasError = touched && error;
  const isSelect = options && options.length > 0;

  /* 🔹 Formik value өөрчлөгдвөл temp sync */
  React.useEffect(() => {
    setTemp(value);
  }, [value]);

  /* 🔹 SAVE */
  const commit = (nextValue: any) => {
    if (nextValue !== value) {
      setValue(nextValue);
    }
    setEditing(false);
  };

  /* ================= EDIT MODE ================= */
  if (editing) {
    return (
      <div className="flex flex-col gap-1 w-full">
        {isSelect ? (
          <Select
            autoFocus
            showSearch
            className="w-[220px]"
            value={temp}
            options={options.map((o) => ({
              label: o.label ?? o.name,
              value: o.value ?? o.code,
            }))}
            optionFilterProp="label"
            /** ✅ SELECT: onChange = FINAL COMMIT */
            onChange={(val) => {
              setTemp(val);
              setValue(val);
              setEditing(false);
            }}
            /** ❌ blur дээр save хийхгүй */
            onBlur={() => setEditing(false)}
            status={hasError ? 'error' : ''}
          />
        ) : type === 'number' ? (
          <>
            {!isNumberFormat ? (
              <InputNumber
                autoFocus
                className="w-full"
                value={temp}
                onChange={(val) => setTemp(val)}
                onBlur={() => commit(temp)}
                onKeyDown={(e) => e.key === 'Enter' && commit(temp)}
                status={hasError ? 'error' : ''}
              />
            ) : (
              <InputNumber
                autoFocus
                className="w-full"
                value={temp}
                onChange={(val) => setTemp(val)}
                onBlur={() => commit(temp)}
                formatter={formatter}
                parser={parser}
                onKeyDown={(e) => e.key === 'Enter' && commit(temp)}
                status={hasError ? 'error' : ''}
              />
            )}
          </>
        ) : (
          <input
            autoFocus
            className={`border rounded px-2 py-1 w-full ${
              hasError ? 'border-red-500' : 'border-[#E5E7EB]'
            }`}
            value={temp ?? ''}
            onChange={(e) => setTemp(e.target.value)}
            onBlur={() => commit(temp)}
            onKeyDown={(e) => e.key === 'Enter' && commit(temp)}
          />
        )}

        {hasError && <div className="text-red-500 text-xs">{error}</div>}
      </div>
    );
  }

  /* ================= VIEW MODE ================= */
  const displayValue = () => {
    if (!value) {
      return (
        <span className={hasError ? 'text-red-500' : 'text-gray-400 italic'}>
          {hasError ? error : 'утга оруулах...'}
        </span>
      );
    }

    if (isNumberFormat) {
      return textFormatter(value);
    }

    if (options?.length) {
      const found = options.find((o) => o.value === value || o.code === value);
      return found?.label || found?.name || value;
    }

    return value;
  };

  return (
    <div
      className="cursor-pointer p-2 rounded hover:bg-gray-100 w-full"
      onClick={() => setEditing(true)}
    >
      {displayValue()}
    </div>
  );
};

const HistoryCard = ({ payload }: { payload: any }) => {
  const status = useMemo(() => {
    switch (payload.status) {
      case 'PENDING':
        return <Tag color="yellow">Хүлээгдэж буй</Tag>;
      case 'RETURNED':
        return <Tag color="blue">Буцаасан</Tag>;
      case 'REJECTED':
        return <Tag color="red">Татгалзсан</Tag>;
      case 'VALUATED':
        return <Tag color="green">Үнэлсэн</Tag>;
      case 'DRAFT':
        return <Tag color="gray">Ноорог</Tag>;
      default:
    }
  }, [payload.status]);

  return (
    <div>
      <div className="h-[16px]" />
      <div className="h-[184px] rotate-0 opacity-100 w-full rounded-[10px] border border-[#E5E7EB] p-[10px]">
        <div className="flex flex-row w-full justify-between items-center">
          <div className="font-manrope font-normal text-[12px] leading-[16px] tracking-[0px] text-[#101828]">
            {dayjs(payload.updatedAt).format('YYYY-MM-DD')}
          </div>
          {status}
        </div>

        <div className="h-[8px]" />

        <div>
          <div className="font-manrope font-normal text-[12px] leading-[16px] tracking-[0px] text-[#6A7282]">
            Үнэ
          </div>
          <div className="font-manrope font-bold text-[12px] leading-[16px] tracking-[0px] text-[#5869FF]">
            {formatCurrency(payload.price)}
          </div>
        </div>
        {/*  */}
        <div className="h-[8px]" />
        <div>
          <div className="font-manrope font-normal text-[12px] leading-[16px] tracking-[0px] text-[#6A7282]">
            Овог, нэр
          </div>
          <div className="font-manrope font-normal text-[12px] leading-[16px] tracking-[0px] text-[#101828]">
            {payload.valuationUser?.lastName} {payload.valuationUser?.firstName}
          </div>
        </div>
        {/*  */}
        <div className="h-[8px]" />
        <div>
          <div className="font-manrope font-normal text-[12px] leading-[16px] tracking-[0px] text-[#6A7282]">
            Салбар
          </div>
          <div className="font-manrope font-normal text-[12px] leading-[16px] tracking-[0px] text-[#101828]">
            {payload?.branch?.name}
          </div>
        </div>
      </div>
    </div>
  );
};

const InquireForm = memo(({ setPayload }: { setPayload?: any }) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const validationSchema = Yup.object().shape({
    vinOrPlateNumber: Yup.string()
      .matches(
        /^([A-HJ-NPR-Z0-9]{9,17}|[0-9]{4}[А-Яа-яҮүӨөЁё\s]{3})$/,
        'Арлын дугаар / улсын дугаар биш байна'
      )
      .required('Заавал оруулна'),
  });

  const onSubmit = async (values: { vinOrPlateNumber?: string }) => {
    messageApi.loading('Хүлээнэ үү...');
    try {
      setLoading(true);

      await delay(500);
      setPayload(undefined);
      const res = await VehicleApi.inquire({ vinOrPlateNumber: values.vinOrPlateNumber ?? '' });

      if (Object.keys(res).length === 0) {
        console.log('Res :', res);
        messageApi.destroy();
        messageApi.error(
          'Машин олдсонгүй! Та үнэлэх автомашины мэдээллээ гараас оруулж, үнэлгээ хийнэ үү.',
          10
        );
        setPayload(res);
        setLoading(false);

        return;
      }

      console.log('Res :', res);
      messageApi.destroy();
      messageApi.success('Амжилттай');
      setPayload(res);
      setLoading(false);
    } catch (error: any) {
      messageApi.destroy();
      setLoading(false);
      messageApi.error(error?.message);
      console.log(error);
    }
  };

  // 8449УБЯ

  return (
    <>
      {contextHolder}
      <InquireFormContainer className="flex flex-1">
        <Formik
          validationSchema={validationSchema}
          enableReinitialize
          initialValues={{
            vinOrPlateNumber: undefined,
          }}
          onSubmit={onSubmit}
        >
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => {
            return (
              <Form
                layout="vertical"
                style={{ display: 'flex', flex: 1, width: '100%', flexDirection: 'column' }}
              >
                <Form.Item
                  name="vinOrPlateNumber"
                  label="Арлын дугаар / улсын дугаар"
                  style={{ display: 'flex', flex: 1, width: '100%' }}
                  required
                >
                  <TextInput
                    required
                    name="vinOrPlateNumber"
                    placeholder="1G1YZ23.../ 1234УБН"
                    style={{ display: 'flex', flex: 1, width: '100%' }}
                  />
                </Form.Item>

                <Button type="primary" onClick={() => handleSubmit()}>
                  <SearchIcon width={17} height={17} color="white" />
                  <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.15px] text-center">
                    Хайх
                  </div>
                </Button>
              </Form>
            );
          }}
        </Formik>
      </InquireFormContainer>
    </>
  );
});

const InquireFormContainer = styled.div`
  :where(.css-dev-only-do-not-override-1v28nim).ant-form-item-vertical .ant-form-item-row {
    width: 100% !important;
  }
`;
